import React,{Component} from 'react';
import Head from './Head'
import Foot from './Foot'
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import Button from 'material-ui/Button';
import { withStyles, MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import Label from './Label'
import { getJSON } from 'jquery'
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Divider from 'material-ui/Divider';

import ExpansionPanel, {
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from 'material-ui/ExpansionPanel';



class WriteBlog extends Component{



    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: event.target.value});
        console.log(this.state)
    }



    render(){

        const theme = createMuiTheme({
            palette: {
                primary: green,
            },
        });


        return(
            <div id="cc" style={{height:'100%',overflow: 'auto'}}>


                <Head src='image/aboutHeader.jpg' title='ABOUT' sentence='Prepare your doubts Eat them up' />
                <div style={{backgroundImage:'url(\'image/pageBackground.jpg\')',backgroundColor:'white',backgroundSize:'cover',padding:'50px 5% 50px',
                    backgroundPositionX:'center',
                    backgroundPositionY: 'top',
                    boxShadow: '0px 10px 10px 10px  #888888 inset',minHeight:'100%'
                }}>


                    <Grid  container spacing={24}style={{display:'flex',
                        flexDirection:'row-reverse',
                        flexWrap:'warp',
                        justifyContent:'flex-start'}}>
                        <Grid item  sm={2} />
                        <Grid item xs={12} sm={8}>
                            <div style={{textAlign:'center'}}>
                            <h1 style={{fontWeight:'lighter'}}>ABOUT BLOG</h1>
                            </div>
                            <Paper >
                                <div style={{height:'250px',backgroundImage:'url(\'image/projectHeader.jpg\')',backgroundSize:'cover',
                                    backgroundPositionX: 'left',
                                    backgroundPositionY: 'medium',position:'relative',boxShadow: '0px 5px 10px #888888',}}>
                                    <h3 style={{fontWeight:'lighter',position:'absolute',bottom:'3px',left:'20px',color:'white'}}>Why is a raven like a writing desk?</h3>
                                </div>
                                <div style={{padding:'20px'}}>
                                    <h4 style={{color: '#fa9b88'}}><b>Web Design</b></h4>
                                    <p><span style={{fontWeight:'lighter'}}>React,Material-UI,a cut-forms Blog</span></p>
                                    <h4 style={{color: '#fa9b88'}}><b>Others</b></h4>
                                    <p><span  style={{fontWeight:'lighter'}}>Text Editor:react-draft-wysiwyg</span></p>
                                    <p><span  style={{fontWeight:'lighter'}}>Side Bar:react-burger-menu</span></p>
                                    <h4 style={{color: '#fa9b88'}}><b>Me?</b></h4>
                                    <p><span  style={{fontWeight:'lighter'}}>I'm Kayer o_O</span></p>
                                    <p><span  style={{fontWeight:'lighter'}}>Email : a1731969799@163.com</span></p>
                                </div>

                            </Paper>

                        </Grid>







                    </Grid>




                </div>
                <Foot src='image/aboutFooter.jpg'  sentence='till my life come to an end' info='© 2018 By Kayer'  />
            </div>
        )
    }





}
export default WriteBlog;


// WEBPACK FOOTER //
// ./src/Compent/page/About.js